import cx from 'classnames'
import React from 'react'

import { selectNavigationMenu } from '../../../stores/selectors'

import { NavigationCollapse } from './NavigationCollapse'
import { NavigationLinkMobile } from './NavigationLinkMobile'

export type Props = {
  isOpen: boolean
}

export const NavigationMobile = ({ isOpen }: Props) => {
  const navigationMenu = selectNavigationMenu()

  return (
    <nav
      id='wl-spainholiday-header-navigation-mobile'
      className={cx('text-sm', { hidden: !isOpen })}
    >
      <NavigationCollapse submenu={navigationMenu.travellers.submenu}>
        {navigationMenu.travellers.text}
      </NavigationCollapse>
      {navigationMenu.homeOwners != null && (
        <NavigationCollapse submenu={navigationMenu.homeOwners.submenu}>
          {navigationMenu.homeOwners.text}
        </NavigationCollapse>
      )}
      <NavigationLinkMobile url={navigationMenu.login.href}>
        {navigationMenu.login.text}
      </NavigationLinkMobile>
    </nav>
  )
}
